/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('relationmailgroupsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/relationmailgroup/relationmailgroup-tab.html',
		controller: 'RelationMailGroupTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('bookingsOverviewMappedByClient', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/booking/booking-tab.html',
		controller: 'BookingTabController',
		scope: {
			clientId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('carsOverviewMappedByOwner', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/car/car-tab.html',
		controller: 'CarTabController',
		scope: {
			ownerId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('subscriptionsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/subscription/subscription-tab.html',
		controller: 'SubscriptionTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('documentsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/document/document-tab.html',
		controller: 'DocumentTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('instructorsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/instructor/instructor-tab.html',
		controller: 'InstructorTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('eventrelationcontactsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-tab.html',
		controller: 'EventRelationContactTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userEventRelationContactMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-list-user.tab.html',
		controller: 'UserEventRelationContactListDtoTabController',
		scope: {
			relationId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('articlerelationpricesOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/articlerelationprice/articlerelationprice-tab.html',
		controller: 'ArticleRelationPriceTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});
